import React from 'react';
import { StyledItem, StyledPreset, StyledText } from '../App.styled';
import { getResourceUrl } from '../utils';

export const PresetItem = ({ preset, selected, onSelection, displayAsset, cloudName }) => {

    const onClick = () => onSelection(preset.transformation);
    const img = getResourceUrl({ asset: displayAsset, transformation: preset.transformation, cloudName });

    return (
        <StyledItem
            key={preset.id}
            showCheckIconWhenSelected
            isSelected={selected}
            selectionVariant="subtle"
            onClick={onClick}
        >
            <StyledPreset img={img}/>
            <StyledText>{preset.name}</StyledText>
        </StyledItem>
    );
};
